module.exports = __webpack_public_path__ + "img/082-rain-1.b5d0a192.svg";